import React, { Component } from 'react';
import { Formik, Form, Field, FieldArray } from 'formik';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { updateFormData, setListing, updateListing } from '../actions';
import { populateListingFromFormData } from '../helpers';

const mapStateToProps = state => ({
  listing: state.Listing
});

class ListingFormCalendars extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isSubmitting: false
    }
    const workflow = this.props.workflow ? this.props.workflow : 'forms';
    this.nextPage = `/${this.props.parent}/listing/${workflow}/manageAvailability`;
    this.prevPage = `/${this.props.parent}/listing/${workflow}/addOns`;
  }

  exit = (values, { setSubmitting }) => {
    this.setState({ isSubmitting: true });
    let { dispatch, history } = this.props;
    let updatedData = populateListingFromFormData(values);
    setTimeout(() => {
      setSubmitting(false);
      dispatch(setListing(updatedData));
      dispatch(updateListing());
      history.push(`/${this.props.parent}/manage-listings?view=ma`);
    }, 1000)
  }

  saveListing = (values, pathAfterSave) => {
    this.setState({ isSubmitting: true })
    let { dispatch, history, listing, step, workflow } = this.props;
    if (values.lastCompleted < step) { values.lastCompleted = step; }

    setTimeout(() => {
      values.calendars = values.calendars.filter(c => c);
      dispatch(updateFormData(values)); // not needed?
      let updatedData = populateListingFromFormData(values);
      if (!updatedData._id) {
        updatedData._id = listing.listingData._id;
      }
      dispatch(setListing(updatedData));
      dispatch(updateListing()).then(() => {
        if (workflow === 'edit')
          history.goBack();
        else
          history.push(pathAfterSave);
      })
    }, 1000);
  }

  submitAndExit = (values) => {
    this.saveListing(values, `/${this.props.parent}/manage-listings`);
  }

  submitAndBack = (values) => {
    this.saveListing(values, this.prevPage);
  }

  onSubmit = (values, { setSubmitting }) => {
    setSubmitting(false);
    this.saveListing(values, this.nextPage);
  }

  render() {
    let stateValues = this.props.listing.formData;
    let exportLink = `${location.origin}/api/ical/${stateValues.id}`;
    const submitText = this.props.exit ? 'Save' : 'Next';
    return (
      <Formik onSubmit={this.props.exit ? this.exit : this.onSubmit} initialValues={stateValues}>
        {({ values, setFieldValue, submitForm }) => (
          <Form>
            <div>
              <div>
                <h5>Import Calendars</h5>
                <div>
                  If you list your property elsewhere, keep your listing availability
                  synced by importing your other calendars. Our calendar supports
                  syncing up to 6 different calendars (e.g. Airbnb, VRBO, etc.)
                </div>
              </div>

              <FieldArray name="calendars" render={(arrayHelpers) => (
                <div>
                  {values.calendars.length > 0 &&
                    values.calendars.map((cal, index) => (
                      <div key={index} className="fieldgroup row">
                        <Field name={`calendars.${index}`} type="text" placeholder="Calendar Address (URL)" className="form-control col-10 col-sm-11" />
                        <i className="fas fa-times fa-2x col-1" onClick={() => {
                          arrayHelpers.remove(index);
                          this.props.dispatch(updateFormData(values));
                        }}></i>
                      </div>
                    ))
                  }
                  {values.calendars.length < 6 &&
                    <div className="text-center m-3">
                      <button className="btn-primary" type="button" onClick={() => {
                        arrayHelpers.push('');
                        this.props.dispatch(updateFormData(values));
                      }}>Add a calendar to sync <i className="fas fa-plus fa-plus-white"></i></button>
                    </div>
                  }
                </div>
              )} />
              {this.props.workflow === 'edit' &&
                <div className="mb-5">
                  <h5>Export CollegeWeekends.com Calendar</h5>
                  <div>
                    Copy and paste the link below into other iCal applications or click the download button to download the .iCal file locally.
                  </div>
                  <div className="fieldgroup row">
                    <div className="fake-input col-10 col-sm-11">{exportLink}</div>
                    <a href={exportLink} title="Download iCal" className="col-1" target="_blank"><i className="fas fa-download fa-2x"></i></a>
                  </div>
                </div>
              }
            </div>
            <div className="button-row row" >
              <div className="col-4" >
                <label className="float-left"
                  onClick={() => { this.submitAndBack(values) }}>Back</label>
              </div>
              <div className="col-8">
                <div className="row">
                  <div className="col-md-6 col-12">
                    {
                      this.props.workflow !== "edit" &&
                      <label className="float-right"
                        onClick={() => { this.submitAndExit(values) }}>Save & Finish Later</label>
                    }
                  </div>
                  <div className="col-md-6 col-12">
                    {
                      this.state.isSubmitting ?
                        <button className="btn-primary float-right"
                          disabled={true} onClick={() => { }}>Saving...</button> :
                        <button className="btn-primary float-right" type="submit">
                          {submitText}
                        </button>
                    }
                  </div>
                </div>
              </div>
            </div>
          </Form>
        )}
      </Formik>
    )
  }
}

export default withRouter(connect(mapStateToProps)(ListingFormCalendars));
